module.exports = __webpack_public_path__ + "static/gallery-19-718129df06e91e8c7afec2d2b8f757bb.jpeg";